import React, { useState, useContext } from 'react'
import { useGlobals } from 'context'
import { Trans } from '@lingui/macro'
import {
  getAnnualPassSettings,
  getMemberPassSettings,
  getSeasonPassSettings,
  getPaymentSettings
  // updateAnnualPassSettings
} from 'pages/Loyalty/api'

const LoyaltySettingsContext = React.createContext()

function LoyaltySettingsProvider({ children }) {
  const { createError } = useGlobals()
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState({
    annual_active: false,
    member_active: false,
    season_active: false
  })

  async function fetch() {
    try {
      setLoading(true)
      const [annual, member, season, payment] = await Promise.all([
        getAnnualPassSettings().then(response => response.data),
        getMemberPassSettings().then(response => response.data),
        getSeasonPassSettings().then(response => response.data),
        getPaymentSettings().then(response => response.data)
      ])
      setData({
        annual_active: Boolean(
          annual.elektra_event_no &&
            annual.elektra_event_no !== '' &&
            annual.elektra_debitor_class &&
            annual.elektra_debitor_class.length !== 0
        ),
        member_active: Boolean(
          member.elektra_event_no &&
            member.elektra_event_no !== '' &&
            member.elektra_debitor_class &&
            member.elektra_debitor_class.length !== 0
        ),
        season_active: Boolean(
          season.elektra_event_no &&
            season.elektra_event_no !== '' &&
            season.elektra_debitor_class &&
            season.elektra_debitor_class.length !== 0
        ),
        annual,
        member,
        season,
        payment
      })
      setLoading(false)
    } catch (error) {
      createError(error, <Trans>Loyalty settings</Trans>, 'read')
      setLoading(false)
    }
  }

  return (
    <LoyaltySettingsContext.Provider
      value={{
        fetch,
        loading,
        data,
        setData
      }}
    >
      {children}
    </LoyaltySettingsContext.Provider>
  )
}

function useLoyaltySettings() {
  return useContext(LoyaltySettingsContext)
}

export { LoyaltySettingsProvider, useLoyaltySettings }
